/**
 * Rotmodus für die Nacht an Bord.
 *
 * Wer nachts aufs Display schaut, verliert die Dunkeladaption. Deshalb gibt es
 * einen Knopf, der die ganze Oberfläche in rotes Monochrom legt: eine
 * Farbmatrix, die die Helligkeit in den Rotkanal schreibt und Grün und Blau
 * auf null setzt. Dieselbe Matrix steckt im SVG-Filter der Seite und in der
 * Prüfung, damit gemessen wird, was der Nutzer sieht.
 */

/** Zeilen der Farbmatrix für Rot, angewandt auf (r, g, b). */
export const NIGHT_VISION_MATRIX = [0.34, 0.5, 0.16] as const

export const NIGHT_VISION_FILTER_ID = 'nightvision'

/** Der Filter, den die Seite einbettet. Bewusst als SVG, nicht als Kette aus CSS-Filtern. */
export function nightVisionFilterSvg(): string {
  const [r, g, b] = NIGHT_VISION_MATRIX
  return `<svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" style="position:absolute">
  <filter id="${NIGHT_VISION_FILTER_ID}" color-interpolation-filters="sRGB">
    <feColorMatrix type="matrix" values="${r} ${g} ${b} 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0" />
  </filter>
</svg>`
}

/** Dieselbe Rechnung wie der Filter, für Messungen am Bild. */
export function applyNightVision(pixel: [number, number, number, number]): [number, number, number, number] {
  const [r, g, b] = NIGHT_VISION_MATRIX
  const red = Math.min(255, Math.round(pixel[0] * r + pixel[1] * g + pixel[2] * b))
  return [red, 0, 0, pixel[3]]
}
